export const unknownType = { kind: 'unknown-type' };
export const holeType = { kind: 'hole-type' };
export const selfType = { kind: 'generic', name: 'Self', key: 'Self', bounds: [] };
export const unitType = {
    kind: 'vid-type',
    identifier: { names: ['std', 'unit', 'Unit'] },
    typeArgs: []
};
export const neverType = {
    kind: 'vid-type',
    identifier: { names: ['std', 'never', 'Never'] },
    typeArgs: []
};
//# sourceMappingURL=type.js.map